import { render, staticRenderFns } from "./EstatisticasCredito.vue?vue&type=template&id=6e2267d5&scoped=true&"
import script from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
export * from "./EstatisticasCredito.vue?vue&type=script&lang=js&"
import style0 from "./EstatisticasCredito.vue?vue&type=style&index=0&id=6e2267d5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2267d5",
  null
  
)

export default component.exports